/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconLockedFortress: {
  name: 'locked_fortress';
  data: string;
} = {
  name: 'locked_fortress',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="m147.186 416.263-28.205 168.411h382.428l-28.205-168.411h-30.916V197.48l55.261-61.812V24.639h-64.471v52.568h-39.265V24.639h-64.472v52.568h-38.78V24.639H226.09v52.568h-38.78V24.639h-64.468v-.003l-.004.003h.003v111.027l55.261 61.812v218.785h-30.916zm163.009-193.6c23.165 0 41.944 18.779 41.944 41.944 0 16.004-8.965 29.91-22.145 36.981l21.215 107.692h-82.046l21.217-107.7c-13.171-7.074-22.129-20.975-22.129-36.973 0-23.165 18.779-41.944 41.944-41.944z"/></svg>`,
};
